// imports section Start
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled, useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import MenuItem from "@mui/material/MenuItem";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  TextField,
  Radio,
  RadioGroup,
  FormLabel,
  FormControl,
  FormControlLabel,
  capitalize,
} from "@mui/material";
import { CashierContext } from "../../../features/cashier/Cashier";
// imports section End

const CashierCash = ({ setTotals }) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const {
    discountType,
    setDiscountType,
    discountValue,
    setDiscountValue,
    discountedTotal,
    setDiscountedTotal,
    cashTendered,
    setCashTendered,
    advanceAmount,
    setAdvanceAmount,
    handleCashTenderedChange,
    handleNumericInput,
    shippingCharge,
    setShippingCharge,
    adjustment,
    setAdjustment,
    grossAmount,
    setGrossAmount,
    rawDiscountValue,
    setRawDiscountValue,
    discountAmount,
    handleDiscountValueChange,
  } = useContext(CashierContext);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, CATTYPE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  // Handlers start
  // Handler for advance amount change
  const handleShippingChargeChange = (e) => {
    let input = e.target.value;

    // Allow only valid decimal inputs with up to 2 decimal places
    if (/^\d*\.?\d{0,2}$/.test(input)) {
      // Remove leading zero unless followed by a decimal point
      if (input.startsWith("0") && input[1] !== ".") {
        input = input.slice(1);
      }
      setShippingCharge(input);
    }

    // const value = parseFloat(e.target.value) || 0;
    // setShippingCharge(value);
  };

  // Handler for advance amount change
  const handleAdjustmentChange = (e) => {
    let input = e.target.value;

    // Allow only valid decimal inputs with up to 2 decimal places
    if (/^\d*\.?\d{0,2}$/.test(input)) {
      // Remove leading zero unless followed by a decimal point
      if (input.startsWith("0") && input[1] !== ".") {
        input = input.slice(1);
      }
      setAdjustment(input);
    }

    // const value = parseFloat(e.target.value) || 0;
    // setAdjustment(value);
  };

  // Handler for radio button change
  const handleDiscountTypeChange = (event) => {
    setDiscountType(event.target.value);
    setDiscountValue(""); // Clear the TextField when the discount type changes
    setError(""); // Clear any previous error message
  };

  useEffect(() => {
    const discountAmount =
      discountValue && discountType === "rate"
        ? (grossAmount * discountValue) / 100 // Calculate percentage discount
        : discountType === "amount"
        ? parseFloat(rawDiscountValue) || 0 // Use raw amount directly
        : 0; // No discount by default

    const newDiscountedTotal = grossAmount - discountAmount; // Subtract discount
    setDiscountedTotal(newDiscountedTotal > 0 ? newDiscountedTotal : 0); // Ensure no negative totals
  }, [grossAmount, discountValue, discountType, rawDiscountValue]);
  // Handlers end

  return (
    <Box sx={styles.cs_cash}>
      <Grid container spacing={2} pt={3}></Grid>
      {/*  */}
      <Grid container spacing={2} pt={4}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControl>
            <FormLabel id="discount-type-label">Discount</FormLabel>
            <RadioGroup
              row
              aria-labelledby="discount-type-label"
              name="discount-type"
              value={discountType}
              onChange={handleDiscountTypeChange}
            >
              <FormControlLabel value="rate" control={<Radio />} label="Rate" />
              <FormControlLabel
                value="amount"
                control={<Radio />}
                label="Amount"
              />
            </RadioGroup>
          </FormControl>
          <TextField
            id="discount-input"
            variant="outlined"
            fullWidth
            size="small"
            type="text"
            value={discountType === "amount" ? rawDiscountValue : discountValue}
            onChange={handleDiscountValueChange}
            placeholder={
              discountType === "rate" ? "Enter Rate (%)" : "Enter Amount"
            }
            error={!!error}
            helperText={error}
          />
        </Grid>
        {/* 
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextField
            id="outlined-basic"
            label="Shipping Charge"
            variant="outlined"
            fullWidth
            size="small"
            value={shippingCharge}
            onChange={handleShippingChargeChange}
            inputProps={{
              inputMode: "decimal",
              pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
          
            }}
          />
        </Grid> */}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextField
            id="outlined-basic"
            label="Adjustment"
            variant="outlined"
            fullWidth
            size="small"
            value={adjustment} // bind cash tendered state
            onChange={handleAdjustmentChange}
            inputProps={{
              inputMode: "decimal",
              pattern: "^[0-9]*\\.?[0-9]{0,2}$",
              // style: { textAlign: "right" },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextField
            id="outlined-basic"
            label="Cash Tendered"
            variant="outlined"
            fullWidth
            size="small"
            value={cashTendered} // bind cash tendered state
            onChange={handleCashTenderedChange}
            inputProps={{
              inputMode: "decimal",
              pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
              // style: { textAlign: "right" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export default CashierCash;
